import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HrmComponent } from './hrm.component';
import { AclGuard } from '@aes/acl';
import { AuthGuardService } from '@aes/core/core.module';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: 'hrm',
        component: HrmComponent,
        canActivate: [AuthGuardService, AclGuard],
        data: {
          roles: ['FUNC__FUNC_REQUESTER__APPROVAL']
        },
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            loadChildren: () => import('./hrm-dashboard').then(m => m.HrmDashboardModule),
          },
          {
            path: 'approval-requests',
            loadChildren: () => import('./approval-request/approval-request.module').then(m => m.ApprovalRequestsModule),
          },
          {
            path: 'general-configuration',
            loadChildren: () => import('./general-configuration/general-configuration.module').then(m => m.GeneralConfigurationModule),
          },
          {
            path: 'announcement-management',
            loadChildren: () => {
              import('./announcement-topic/announcement-topic.module').then(m => m.AnnouncementTopicModule);
              return import('./announcement/announcement.module').then(m => m.AnnouncementModule)
            },
          },
          {
            path: 'announcements',
            loadChildren: () => {
              import('./announcement/announcement.module').then(m => m.AnnouncementModule)
              return import('./announcement-topic/announcement-topic.module').then(m => m.AnnouncementTopicModule);
            },
          },
        ],
      },
    ]),
  ],
  exports: [RouterModule],
  declarations: [HrmComponent],
})
export class HrmModule {}
